import AddIntake from "../../Components/Modals/AddIntake";
import AddScholarship from "../../Components/Modals/AddScholarship";
import Table from "../../Components/Table";
import { deleteScholarshipById, getScholarships } from "../../Services/MasterService";

const Scholarship = () => {
    const columns = [
        {
            label: "Provider Name",
            value: "provider_name"
        },
        {
            label: "Provider Type",
            value: "provider_type"
        },
        {
            label: "Total Scholarships",
            value: "total_scholarships"
        },
        {
            label: "Frequency",
            value: "frequency"
        },
        {
            label: "Provider Type",
            value: "provider_type"
        },
        {
            label: "Applicable For",
            value: "applicable_for"
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddScholarship data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getScholarships}
            columns={columns}
            title={"Scholarship Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteScholarshipById}
        />
    );
}

export default Scholarship;